import React from 'react';

export const FloorPlanEditorHeader = ({
  onBack,
  onClear,
  onOpenSave,
  onView3D,
  onRequestConsulta,
  requestingConsulta,
}) => {
  return (
    <div className="bg-white shadow-sm border-b" data-testid="floorplan-editor-header">
      <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <button onClick={onBack} className="text-gray-600 hover:text-gray-900" data-testid="floorplan-editor-back-button">
            ← Voltar
          </button>
          <h1 className="text-xl font-bold text-gray-900" data-testid="floorplan-editor-page-title">Editor de Planta Baixa</h1>
        </div>
        <div className="flex items-center gap-3">
          <button onClick={onClear} className="px-4 py-2 text-red-600 hover:bg-red-50 rounded-lg transition" data-testid="floorplan-editor-clear-button">
            Limpar
          </button>
          <button onClick={onOpenSave} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition" data-testid="floorplan-editor-open-save-modal-button">
            💾 Salvar
          </button>
          <button onClick={onView3D} className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition" data-testid="floorplan-editor-view-3d-button">
            🏠 Ver em 3D
          </button>
          <button
            onClick={onRequestConsulta}
            disabled={requestingConsulta}
            className="px-4 py-2 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-lg hover:from-green-600 hover:to-emerald-700 transition font-semibold shadow-lg disabled:opacity-70"
            data-testid="floorplan-editor-request-consulta-button"
          >
            {requestingConsulta ? '⏳ Enviando...' : '📋 Solicitar Orçamento'}
          </button>
        </div>
      </div>
    </div>
  );
};
